import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefund.List.IRequest;
type Response = Api.Sales.ContractRefund.List.IResponse;
type Headers = Api.Sales.ContractRefund.List.IHeaders;
const url = '/api/Sales/ContractRefund';
export default async function contractRefundListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
